// Module
var code = `<textarea elastic class="tft-textarea {{tftTextAreaCtrl.className}}" ng-model="tftTextAreaCtrl.innerValue" ng-change="tftTextAreaCtrl.valueChange()" placeholder="{{tftTextAreaCtrl.placeholder}}">
</textarea> `;
// Exports
export default code;